/**
 * What the candidate page says when the server declines to show a candidate
 * (403) instead of a profile. In a test workspace that is a real job seeker
 * the tester can see in the list but not open, reached by URL anyway.
 *
 * A plain statement and the way back, not an error: nothing failed, and
 * "try again" would only get the same answer. The server's own reason is the
 * body when it gave one ("In this test workspace you can open only your test
 * candidates."), so the page and the API never word it differently.
 */

import { useId } from 'react';
import { Link } from 'react-router-dom';
import { LockOutlined } from '@ant-design/icons';

import styles from './index.module.css';

export const REFUSAL_TITLE = "You can't open this candidate";
export const REFUSAL_FALLBACK =
  "Your account doesn't have access to this candidate.";
export const REFUSAL_BACK = 'Back to candidate list';

interface Props {
  /** The server's reason, when it gave a short one. */
  message?: string;
  /** Where "Back to candidate list" goes. */
  backTo: string;
}

const RefusalNotice = ({ message, backTo }: Props) => {
  const titleId = useId();
  return (
    <section className={styles.notice} aria-labelledby={titleId}>
      <LockOutlined className={styles.icon} aria-hidden="true" />
      <h1 id={titleId} className={styles.title}>
        {REFUSAL_TITLE}
      </h1>
      <p className={styles.message}>{message || REFUSAL_FALLBACK}</p>
      <Link to={backTo} className={styles.back}>
        {REFUSAL_BACK}
      </Link>
    </section>
  );
};

export default RefusalNotice;
